type NativeWindow = Window & {
  MenuBeezNative?: {
    printOrder?: (...args: unknown[]) => unknown;
    syncPendingJobs?: (...args: unknown[]) => unknown;
    printers?: unknown;
  };
  PepparNative?: NativeWindow['MenuBeezNative'];
  ReactNativeWebView?: { postMessage?: (message: string) => void };
  PepparWeb?: { isNativeApp?: () => boolean };
};

/** True when the page runs inside Peppar Merchant (WebView) or Peppar Rider (native shell). */
export function isPepparMobileApp(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const w = window as NativeWindow;
  const native = w.MenuBeezNative || w.PepparNative;

  if (native?.printOrder || native?.printers || native?.syncPendingJobs) {
    return true;
  }

  if (typeof w.ReactNativeWebView?.postMessage === 'function') {
    return true;
  }

  if (typeof w.PepparWeb?.isNativeApp === 'function' && w.PepparWeb.isNativeApp()) {
    return true;
  }

  const ua = navigator.userAgent || '';
  if (/PepparMerchant|PepparRider|MenuBeezNative|in\.peppar\.(merchant|rider)/i.test(ua)) {
    return true;
  }

  return false;
}
